<template>
  <LayoutFeed
    v-bind="{ getFirstPage, getNextPage, gridClass }"
    :groq-params="groqParams"
    @load-more="onLoadMore"
  >
    <template #header>
      <slot name="header" />
    </template>
    <template #items="{ items, itemClass }">
      <EditorialFeedItem
        v-for="post in items"
        :key="`post-${post._id}`"
        :post="post"
        :class="itemClass"
        :grid-sizes="gridClass"
      />
    </template>
    <template #not-found>
      <slot name="not-found" />
    </template>
  </LayoutFeed>
</template>

<script setup lang="ts">
import type { GridClass } from "~/@types/feed"
import type * as Schema from "~/@types/schema"

const props = withDefaults(
  defineProps<{
    getFirstPage: () => string
    getNextPage: () => string
    groqParams?: Record<string, unknown>
    gridClass?: GridClass
  }>(),
  {
    groqParams: () => ({}),
  },
)

const { groqParams } = toRefs(props)

const onLoadMore = (item: Schema.Editorial) => {
  const { _id, publishedAt } = item

  groqParams.value.lastId = _id
  groqParams.value.lastPublishedAt = publishedAt
}
</script>
